// import React, { useState, useEffect, useRef } from 'react';
// import { useParams } from 'react-router-dom';
// import { useQuery, useQueryClient } from '@tanstack/react-query';
// import { Search, X, Share2, Check } from 'lucide-react';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import '../Style/VehicleDetails.css';
// import carGreenSvg from '../assets/car-green.svg';
// import carYellowSvg from '../assets/car-yellow.svg';
// import carRedSvg from '../assets/car-red.svg';
// import carBlackSvg from '../assets/car-black.svg';
// import carBlueSvg from '../assets/car-blue.svg';
// import { PubSub } from 'aws-amplify';

// // --- Constants ---
// const API_BASE_URL = "https://api.yellowmatrix.co.in";
// const MIN_MOVEMENT_DISTANCE = 10;
// const DEFAULT_MAP_CENTER = [19.253088, 72.868688];
// const DEFAULT_MAP_ZOOM = 10;
// const DEFAULT_LIVE_MAP_ZOOM = 17;
// const FLY_ANIMATION_DURATION = 1.5;

// // --- Helper Functions ---
// const haversineDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371e3;
//     const φ1 = lat1 * Math.PI / 180;
//     const φ2 = lat2 * Math.PI / 180;
//     const Δφ = (lat2 - lat1) * Math.PI / 180;
//     const Δλ = (lon2 - lon1) * Math.PI / 180;
//     const a = Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
//     return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
// };

// const calculateBearing = (from, to) => {
//     if (!from || !to) return to?.Bearing || 0;
//     const φ1 = from.Latitude * Math.PI / 180;
//     const φ2 = to.Latitude * Math.PI / 180;
//     const Δλ = (to.Longitude - from.Longitude) * Math.PI / 180;
//     const y = Math.sin(Δλ) * Math.cos(φ2);
//     const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
//     let θ = Math.atan2(y, x);
//     return (θ * 180 / Math.PI + 360) % 360;
// };

// const getShortestRotation = (currentBearing, newBearing) => {
//     currentBearing = ((currentBearing % 360) + 360) % 360;
//     newBearing = ((newBearing % 360) + 360) % 360;
//     let diff = newBearing - currentBearing;
//     if (diff > 180) diff -= 360;
//     else if (diff < -180) diff += 360;
//     return currentBearing + diff;
// };

// const parsePVT = (pvtString) => {
//     if (!pvtString || !pvtString.startsWith('$,PVT')) return null;
//     const parts = pvtString.split(',');
//     if (parts.length < 30) return null;
//     const convertDMM = (val, dir) => {
//         if (isNaN(val)) return 0;
//         const deg = Math.floor(val / 100);
//         const min = val - deg * 100;
//         const dec = deg + min / 60;
//         return dir === 'S' || dir === 'W' ? -dec : dec;
//     };
//     return {
//         VehicleID: parts[7],
//         GPSFix: parseInt(parts[8]),
//         Latitude: convertDMM(parseFloat(parts[11]), parts[12]),
//         Longitude: convertDMM(parseFloat(parts[13]), parts[14]),
//         Speed: parseFloat(parts[15]),
//         Ignition: parseInt(parts[22]),
//         Bearing: parts.length > 23 ? parseFloat(parts[23]) : 0,
//         LastTime: Date.now()
//     };
// };

// const getVehicleStatus = ({ Speed, Ignition, GPSFix, Location }) => {
//     if (GPSFix === 0 || !Location?.Latitude) return 'NO GPS';
//     if (Speed > 3 && Ignition === 1) return 'RUNNING';
//     if (Ignition === 1 && Speed <= 3) return 'IDLE';
//     if (Ignition === 0) return 'HALT';
//     return 'UNKNOWN';
// };

// const formatDate = (timestamp) => {
//     if (!timestamp) return "No data";
//     return new Date(timestamp).toLocaleString('en-IN', {
//         timeZone: 'Asia/Kolkata',
//         day: 'numeric', month: 'short', year: 'numeric',
//         hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
//     });
// };

// const vehicleIcons = {
//     'RUNNING': carGreenSvg,
//     'IDLE': carYellowSvg,
//     'HALT': carRedSvg,
//     'NO GPS': carBlackSvg,
//     'OFFLINE': carBlueSvg,
//     'UNKNOWN': carBlueSvg,
// };

// // --- API Fetchers ---
// const fetchVehicleDetails = async (vehicleId, token) => {
//     const response = await fetch(`${API_BASE_URL}/vehicles/${vehicleId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//     });
//     if (!response.ok) throw new Error('Failed to fetch vehicle details');
//     return response.json();
// };

// const fetchAllVehicles = async (token) => {
//     const response = await fetch(`${API_BASE_URL}/vehiclereg`, {
//         headers: { Authorization: `Bearer ${token}` },
//     });
//     if (!response.ok) throw new Error('Failed to fetch vehicle list');
//     return response.json();
// };

// const fetchMqttConfig = async (token) => {
//     const response = await fetch(`${API_BASE_URL}/vehiclelivedata`, {
//         headers: { 'Authorization': `Bearer ${token}` },
//     });
//     if (!response.ok) throw new Error('Failed to fetch MQTT topic');
//     return response.json();
// };

// // --- Components ---
// const DetailsSkeleton = () => (
//     <div className="skeleton-container">
//         <p>Loading Vehicle Details...</p>
//     </div>
// );

// const VehicleDetails = () => {
//     const { vehicleId } = useParams();
//     const [selectedVehicleId, setSelectedVehicleId] = useState(vehicleId);
//     const [vehicleSearch, setVehicleSearch] = useState('');
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [address, setAddress] = useState(null);
//     const [addressLoading, setAddressLoading] = useState(false);

//     // Sharing States
//     const [isSharing, setIsSharing] = useState(false);
//     const [copied, setCopied] = useState(false);

//     const mapRef = useRef(null);
//     const markerRef = useRef(null);
//     const searchContainerRef = useRef(null);
//     const smoothRotationRef = useRef(0);
//     const vehicleHistoryRef = useRef(null);
//     const mappedVehicleIdRef = useRef(null);
//     const lastAddressFetchRef = useRef(0);

//     const token = localStorage.getItem('token');
//     const queryClient = useQueryClient();

//     // Queries
//     const { data: allVehiclesData } = useQuery({
//         queryKey: ['allVehicles', token],
//         queryFn: () => fetchAllVehicles(token),
//         enabled: !!token,
//     });

//     const allVehicles = allVehiclesData?.Vehicles || [];

//     const { data: mqttConfig } = useQuery({
//         queryKey: ['mqttConfig', token],
//         queryFn: () => fetchMqttConfig(token),
//         enabled: !!token,
//         staleTime: Infinity,
//     });

//     const { data: vehicleData, isLoading, isError, error } = useQuery({
//         queryKey: ['vehicle', selectedVehicleId, token],
//         queryFn: () => fetchVehicleDetails(selectedVehicleId, token),
//         enabled: !!selectedVehicleId && !!token,
//         onSuccess: (data) => {
//             setVehicleSearch(data.VehicleID);
//             vehicleHistoryRef.current = data;
//         }
//     });

//     // --- Share Logic ---
//     const handleShareLiveLocation = async () => {
//         setIsSharing(true);
//         try {
//             const response = await fetch(`${API_BASE_URL}/share-live-location`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 body: JSON.stringify({ vehicleid: selectedVehicleId })
//             });

//             const data = await response.json();

//             if (response.ok) {
//                 const tokenPart = data.share_url.split('/').pop();
//                 const frontendLink = `${window.location.origin}/SharingMap/${tokenPart}`;

//                 // Copy to clipboard
//                 await navigator.clipboard.writeText(frontendLink);

//                 setCopied(true);
//                 setTimeout(() => setCopied(false), 5000);
//             } else {
//                 alert(data.error || "Failed to generate share link");
//             }
//         } catch (err) {
//             console.error(err);
//             alert("Error connecting to server");
//         } finally {
//             setIsSharing(false);
//         }
//     };

//     // --- Address Lookup ---
//     useEffect(() => {
//         const getAddressFromCoordinates = async (lat, lon) => {
//             const now = Date.now();
//             if (now - lastAddressFetchRef.current < 10000) return;
//             setAddressLoading(true);
//             try {
//                 const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`, {
//                     headers: { 'User-Agent': 'TrackMasterHub/1.0' }
//                 });
//                 const data = await response.json();
//                 setAddress(data.display_name || "Address not available");
//                 lastAddressFetchRef.current = now;
//             } catch (err) {
//                 setAddress("Error loading address");
//             } finally {
//                 setAddressLoading(false);
//             }
//         };

//         if (vehicleData?.Location?.Latitude && vehicleData?.Location?.Longitude) {
//             getAddressFromCoordinates(vehicleData.Location.Latitude, vehicleData.Location.Longitude);
//         }
//     }, [vehicleData?.Location?.Latitude, vehicleData?.Location?.Longitude]);

//     // --- MQTT Subscription (MERGE LOGIC FIXED HERE) ---
//     useEffect(() => {
//         if (!mqttConfig?.topic || !selectedVehicleId) return;
//         const subscription = PubSub.subscribe(mqttConfig.topic).subscribe({
//             next: (data) => {
//                 const liveData = parsePVT(data.value?.PVT);
//                 if (liveData && liveData.VehicleID === selectedVehicleId) {
//                     const previousData = vehicleHistoryRef.current;
//                     let calculatedBearing = liveData.Bearing;
//                     if (previousData?.Location?.Latitude && liveData.Latitude) {
//                         const dist = haversineDistance(previousData.Location.Latitude, previousData.Location.Longitude, liveData.Latitude, liveData.Longitude);
//                         if (dist > MIN_MOVEMENT_DISTANCE) {
//                             calculatedBearing = calculateBearing(previousData.Location, liveData);
//                         } else {
//                             calculatedBearing = previousData.calculatedBearing ?? liveData.Bearing;
//                         }
//                     }
//                     liveData.calculatedBearing = calculatedBearing;

//                     // UPDATED: Merge live updates with existing state to keep totalDistance
//                     queryClient.setQueryData(['vehicle', selectedVehicleId, token], (oldData) => {
//                         if (!oldData) return;
//                         const updatedData = {
//                             ...oldData,      // Preserves totalDistance, driverName, etc.
//                             ...liveData,     // Updates Latitude, Longitude, Speed
//                             Location: {
//                                 ...oldData.Location,
//                                 Latitude: liveData.Latitude,
//                                 Longitude: liveData.Longitude
//                             }
//                         };
//                         vehicleHistoryRef.current = updatedData;
//                         return updatedData;
//                     });
//                 }
//             },
//             error: (err) => console.error('Subscription error:', err),
//         });
//         return () => subscription.unsubscribe();
//     }, [mqttConfig, selectedVehicleId, queryClient, token]);

//    // Map Initialization and Updates
//     useEffect(() => {
//         // Initialize map only once
//         if (!mapRef.current) {
//             mapRef.current = L.map('vehicle-map').setView(DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM);
//             L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(mapRef.current);
//         }

//         const status = vehicleData ? getVehicleStatus(vehicleData) : null;
//         const hasValidGPS = status !== 'NO GPS' && vehicleData?.Location?.Latitude && vehicleData?.Location?.Longitude;

//         if (hasValidGPS) {
//             const { Latitude, Longitude } = vehicleData.Location;
//             const bearing = vehicleData.calculatedBearing ?? vehicleData.Bearing ?? 0;
//             const iconUrl = vehicleIcons[status] || vehicleIcons.UNKNOWN;

//             // --- AUTO-ZOOM & FOLLOW LOGIC ---
//             const isNewVehicle = vehicleData.VehicleID !== mappedVehicleIdRef.current;
//             if (isNewVehicle) {
//                 // When a new vehicle is selected, fly to its location with the live zoom level.
//                 mapRef.current.flyTo([Latitude, Longitude], DEFAULT_LIVE_MAP_ZOOM, {
//                     duration: FLY_ANIMATION_DURATION
//                 });
//                 mappedVehicleIdRef.current = vehicleData.VehicleID;
//             } else {
//                 // For subsequent live updates, set the view to keep the vehicle centered and zoomed.
//                 mapRef.current.setView([Latitude, Longitude], DEFAULT_LIVE_MAP_ZOOM);
//             }

//             // --- MARKER UPDATE LOGIC ---
//             if (markerRef.current) {
//                 markerRef.current.setLatLng([Latitude, Longitude]);
//                 const iconElement = markerRef.current.getElement();
//                 if (iconElement) {
//                     const img = iconElement.querySelector('.vehicle-icon-image');
//                     if (img) {
//                         if (img.src !== iconUrl) img.src = iconUrl;
//                         const currentRotation = smoothRotationRef.current;
//                         const newRotation = getShortestRotation(currentRotation, bearing);
//                         img.style.transition = 'transform 0.7s ease-in-out';
//                         img.style.transform = `rotate(${newRotation}deg)`;
//                         smoothRotationRef.current = newRotation;
//                     }
//                 }
//             } else {
//                 const icon = L.divIcon({
//                     className: "custom-leaflet-div-icon",
//                     html: `<img src="${iconUrl}" class="vehicle-icon-image" style="transform: rotate(${bearing}deg);">`,
//                     iconSize: [37, 37],
//                     iconAnchor: [18, 18],
//                 });
//                 markerRef.current = L.marker([Latitude, Longitude], { icon }).addTo(mapRef.current);
//                 smoothRotationRef.current = bearing;
//             }
//         } else { // Handle case with no GPS
//             if (markerRef.current) {
//                 mapRef.current.removeLayer(markerRef.current);
//                 markerRef.current = null;
//             }
//             if (mappedVehicleIdRef.current) {
//                 mapRef.current.flyTo(DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM, {
//                     duration: FLY_ANIMATION_DURATION
//                 });
//                 mappedVehicleIdRef.current = null;
//             }
//         }
//     }, [vehicleData]);

//     const handleVehicleSelect = (vehicleId) => {
//         setShowDropdown(false);
//         setSelectedVehicleId(vehicleId);
//         setCopied(false);
//     };

//     const filteredVehicles = allVehicles.filter(v => v.VehicleID && v.VehicleID.toLowerCase().includes(vehicleSearch.toLowerCase()));

//     const renderDetailsContent = () => {
//         if (isLoading) return <DetailsSkeleton />;
//         if (isError) return <div className="error">Error: {error.message}</div>;
//         if (!vehicleData) return <div className="error">Vehicle data not found.</div>;
//         const status = getVehicleStatus(vehicleData);
//         return (
//             <>
//                 <div>
//                     <p className="vehicleno-VehicleDetails">VEHICLE: {vehicleData.VehicleID}</p>
//                     <p className="speed-VehicleDetails">Speed (km/h): <span className="font-semibold text-black">{(vehicleData.Speed || 0).toFixed(2)}</span></p>
//                 </div>
//                 <div>
//                     <p className="detail-label-VehicleDetails">Last tracked time</p>
//                     <p className="tracking-time-VehicleDetails">{formatDate(vehicleData.LastTime)}</p>
//                 </div>
//                 <div>
//                     <p className="detail-label-VehicleDetails">Location</p>
//                     <p className="detail-value-VehicleDetails">{addressLoading ? 'Loading address...' : (address || 'N/A')}</p>
//                 </div>
//                 <div>
//                     <p className="detail-label-VehicleDetails">Status</p>
//                     <p className="detail-value-VehicleDetails">{status}</p>
//                 </div>
//                 <hr className="divider-VehicleDetails"/>
//                 <div className="details-grid-VehicleDetails">
//                     <div className="detail-block-VehicleDetails"><p className="detail-label-VehicleDetails">Driver Name</p><p className="detail-value-VehicleDetails">{vehicleData.driverName || "N/A"}</p></div>
//                     <div className="detail-block-VehicleDetails"><p className="detail-label-VehicleDetails">Driver License</p><p className="detail-value-VehicleDetails">{vehicleData.driverLicense || "N/A"}</p></div>
//                     <div className="detail-block-VehicleDetails"><p className="detail-label-VehicleDetails">Driver Contact</p><p className="detail-value-VehicleDetails">{vehicleData.driverContact || "N/A"}</p></div>
//                     <div className="detail-block-VehicleDetails"><p className="detail-label-VehicleDetails">Group Name</p><p className="detail-value-VehicleDetails bold-VehicleDetails">{vehicleData.groupName || "N/A"}</p></div>
//                 </div>
//                 <hr className="divider-VehicleDetails"/>
//                <div>
//                 <p className="detail-label-VehicleDetails">Total Distance (Past 3 Months)</p>
//                 <p className="detail-value-VehicleDetails">
//                 {   vehicleData?.totalDistance ??
//                     vehicleData?.TotalDistance ??
//                     vehicleData?.total_distance ??
//                     "N/A"} Km
//                  </p>
//                 </div>
//                 </>
//         );
//     };

//     return (
//         <div className="main-container-VehicleDetails">
//             <div className="screen-layout-VehicleDetails">
//                 <div className="info-panel-VehicleDetails">
//                     <div className="search-container-VehicleDetails" ref={searchContainerRef}>
//                         <label htmlFor="vehicle-number" className="search-label-VehicleDetails">Vehicle Number</label>
//                         <div className="search-input-wrapper-VehicleDetails">
//                             <Search className="search-icon-VehicleDetails" />
//                             <input
//                                 id="vehicle-number" type="text" value={vehicleSearch}
//                                 onChange={(e) => { setVehicleSearch(e.target.value); setShowDropdown(true); }}
//                                 className="search-input-VehicleDetails" autoComplete="off" placeholder="Search vehicle..."
//                             />
//                             {vehicleSearch && <X className="clear-search-icon-VehicleDetails" onClick={() => setVehicleSearch('')} />}
//                         </div>
//                         {showDropdown && (
//                             <ul className="search-results-list-VehicleDetails">
//                                 {filteredVehicles.length > 0 ? (
//                                     filteredVehicles.map((v) => (
//                                         <li key={v.VehicleID} onClick={() => handleVehicleSelect(v.VehicleID)} className="search-result-item-VehicleDetails">{v.VehicleID}</li>
//                                     ))
//                                 ) : <li className="search-no-results-VehicleDetails">No vehicles found</li>}
//                             </ul>
//                         )}
//                     </div>

//                           <div className="share-button-container-VehicleDetails">
//                         <button
//                             className={`share-button-VehicleDetails ${copied ? 'copied-success' : ''}`}
//                             onClick={handleShareLiveLocation}
//                             disabled={isSharing || copied}
//                         >
//                             {isSharing ? (
//                                 <div className="animate-spin-VehicleDetails"></div>
//                             ) : copied ? (
//                                 <Check size={18} />
//                             ) : (
//                                 <Share2 size={18} />
//                             )}
//                             <span>
//                                 {isSharing ? 'GENERATING...' : copied ? 'LINK COPIED!' : 'SHARE LIVE LOCATION'}
//                             </span>
//                         </button>
//                     </div>

//                     <div className="details-section-VehicleDetails">{renderDetailsContent()}</div>
//                 </div>

//                 <div className="map-panel-VehicleDetails">
//                      <div className="tracking-tabs-header">
//                     <button className="tracking-tab active">TRACKING LIVE</button>
//                     <button className="tracking-tab">TRAVEL REPLAY</button>
//                  </div>
//                    <div id="vehicle-map" className="map-placeholder-VehicleDetails"></div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default VehicleDetails;


import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Search, X, Share2, Check } from "lucide-react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../Style/VehicleDetails.css";
import carGreenSvg from "../assets/car-green.svg";
import carYellowSvg from "../assets/car-yellow.svg";
import carRedSvg from "../assets/car-red.svg";
import carBlackSvg from "../assets/car-black.svg";
import carBlueSvg from "../assets/car-blue.svg";
import { PubSub } from "aws-amplify";

const API_BASE_URL = "https://api.yellowmatrix.co.in";
const MIN_MOVEMENT_DISTANCE = 10;
const DEFAULT_MAP_CENTER = [19.253088, 72.868688];
const DEFAULT_MAP_ZOOM = 10;
const DEFAULT_LIVE_MAP_ZOOM = 17;
const FLY_ANIMATION_DURATION = 1.5;

const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3;
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

const calculateBearing = (from, to) => {
  if (!from || !to) return to?.Bearing || 0;
  const φ1 = (from.Latitude * Math.PI) / 180;
  const φ2 = (to.Latitude * Math.PI) / 180;
  const Δλ = ((to.Longitude - from.Longitude) * Math.PI) / 180;
  const y = Math.sin(Δλ) * Math.cos(φ2);
  const x =
    Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
  let θ = Math.atan2(y, x);
  return ((θ * 180) / Math.PI + 360) % 360;
};

const getShortestRotation = (currentBearing, newBearing) => {
  currentBearing = ((currentBearing % 360) + 360) % 360;
  newBearing = ((newBearing % 360) + 360) % 360;
  let diff = newBearing - currentBearing;
  if (diff > 180) diff -= 360;
  else if (diff < -180) diff += 360;
  return currentBearing + diff;
};

const parsePVT = (pvtString) => {
  if (!pvtString || !pvtString.startsWith("$,PVT")) return null;
  const parts = pvtString.split(",");
  if (parts.length < 30) return null;
  const convertDMM = (val, dir) => {
    if (isNaN(val)) return 0;
    const deg = Math.floor(val / 100);
    const min = val - deg * 100;
    const dec = deg + min / 60;
    return dir === "S" || dir === "W" ? -dec : dec;
  };
  return {
    VehicleID: parts[7],
    GPSFix: parseInt(parts[8]),
    Latitude: convertDMM(parseFloat(parts[11]), parts[12]),
    Longitude: convertDMM(parseFloat(parts[13]), parts[14]),
    Speed: parseFloat(parts[15]),
    Ignition: parseInt(parts[22]),
    Bearing: parts.length > 23 ? parseFloat(parts[23]) : 0,
    LastTime: Date.now(),
  };
};

const getVehicleStatus = ({ Speed, Ignition, GPSFix, Location }) => {
  if (GPSFix === 0 || !Location?.Latitude) return "NO GPS";
  if (Speed > 3 && Ignition === 1) return "RUNNING";
  if (Ignition === 1 && Speed <= 3) return "IDLE";
  if (Ignition === 0) return "HALT";
  return "UNKNOWN";
};

const formatDate = (timestamp) => {
  if (!timestamp) return "No data";
  return new Date(timestamp).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

const vehicleIcons = {
  RUNNING: carGreenSvg,
  IDLE: carYellowSvg,
  HALT: carRedSvg,
  "NO GPS": carBlackSvg,
  OFFLINE: carBlueSvg,
  UNKNOWN: carBlueSvg,
};

const fetchVehicleDetails = async (vehicleId, token) => {
  const response = await fetch(`${API_BASE_URL}/vehicles/${vehicleId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Failed to fetch vehicle details");
  return response.json();
};

const fetchAllVehicles = async (token) => {
  const response = await fetch(`${API_BASE_URL}/vehiclereg`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Failed to fetch vehicle list");
  return response.json();
};

const fetchMqttConfig = async (token) => {
  const response = await fetch(`${API_BASE_URL}/vehiclelivedata`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Failed to fetch MQTT topic");
  return response.json();
};

const DetailsSkeleton = () => (
  <div className="skeleton-container">
    <p>Loading Vehicle Details...</p>
  </div>
);

const VehicleDetails = () => {
  const { vehicleId } = useParams();
  const [selectedVehicleId, setSelectedVehicleId] = useState(vehicleId);
  const [vehicleSearch, setVehicleSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [address, setAddress] = useState(null);
  const [addressLoading, setAddressLoading] = useState(false);

  const [isSharing, setIsSharing] = useState(false);
  const [copied, setCopied] = useState(false);

  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const searchContainerRef = useRef(null);
  const smoothRotationRef = useRef(0);
  const vehicleHistoryRef = useRef(null);
  const mappedVehicleIdRef = useRef(null);
  const lastAddressFetchRef = useRef(0);

  const token = localStorage.getItem("token");
  const queryClient = useQueryClient();

  const { data: allVehiclesData } = useQuery({
    queryKey: ["allVehicles", token],
    queryFn: () => fetchAllVehicles(token),
    enabled: !!token,
  });

  const allVehicles = allVehiclesData?.Vehicles || [];

  const { data: mqttConfig } = useQuery({
    queryKey: ["mqttConfig", token],
    queryFn: () => fetchMqttConfig(token),
    enabled: !!token,
    staleTime: Infinity,
  });

  const {
    data: vehicleData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["vehicle", selectedVehicleId, token],
    queryFn: () => fetchVehicleDetails(selectedVehicleId, token),
    enabled: !!selectedVehicleId && !!token,
    onSuccess: (data) => {
      setVehicleSearch(data.VehicleID);
      vehicleHistoryRef.current = data;
    },
  });

  const handleShareLiveLocation = async () => {
    setIsSharing(true);
    try {
      const response = await fetch(`${API_BASE_URL}/share-live-location`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ vehicleid: selectedVehicleId }),
      });

      const data = await response.json();

      if (response.ok) {
        const tokenPart = data.share_url.split("/").pop();
        const frontendLink = `${window.location.origin}/SharingMap/${tokenPart}`;

        await navigator.clipboard.writeText(frontendLink);

        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
      } else {
        alert(data.error || "Failed to generate share link");
      }
    } catch (err) {
      console.error(err);
      alert("Error connecting to server");
    } finally {
      setIsSharing(false);
    }
  };

  useEffect(() => {
    const getAddressFromCoordinates = async (lat, lon) => {
      const now = Date.now();
      if (now - lastAddressFetchRef.current < 10000) return;
      setAddressLoading(true);
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`,
          {
            headers: { "User-Agent": "TrackMasterHub/1.0" },
          },
        );
        const data = await response.json();
        setAddress(data.display_name || "Address not available");
        lastAddressFetchRef.current = now;
      } catch (err) {
        setAddress("Error loading address");
      } finally {
        setAddressLoading(false);
      }
    };

    if (vehicleData?.Location?.Latitude && vehicleData?.Location?.Longitude) {
      getAddressFromCoordinates(
        vehicleData.Location.Latitude,
        vehicleData.Location.Longitude,
      );
    }
  }, [vehicleData?.Location?.Latitude, vehicleData?.Location?.Longitude]);

  useEffect(() => {
    if (!mqttConfig?.topic || !selectedVehicleId) return;
    const subscription = PubSub.subscribe(mqttConfig.topic).subscribe({
      next: (data) => {
        const liveData = parsePVT(data.value?.PVT);
        if (liveData && liveData.VehicleID === selectedVehicleId) {
          const previousData = vehicleHistoryRef.current;
          let calculatedBearing = liveData.Bearing;
          if (previousData?.Location?.Latitude && liveData.Latitude) {
            const dist = haversineDistance(
              previousData.Location.Latitude,
              previousData.Location.Longitude,
              liveData.Latitude,
              liveData.Longitude,
            );
            if (dist > MIN_MOVEMENT_DISTANCE) {
              calculatedBearing = calculateBearing(
                previousData.Location,
                liveData,
              );
            } else {
              calculatedBearing =
                previousData.calculatedBearing ?? liveData.Bearing;
            }
          }
          liveData.calculatedBearing = calculatedBearing;

          queryClient.setQueryData(
            ["vehicle", selectedVehicleId, token],
            (oldData) => {
              if (!oldData) return;
              const updatedData = {
                ...oldData,
                ...liveData,
                Location: {
                  ...oldData.Location,
                  Latitude: liveData.Latitude,
                  Longitude: liveData.Longitude,
                },
              };
              vehicleHistoryRef.current = updatedData;
              return updatedData;
            },
          );
        }
      },
      error: (err) => console.error("Subscription error:", err),
    });
    return () => subscription.unsubscribe();
  }, [mqttConfig, selectedVehicleId, queryClient, token]);

  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = L.map("vehicle-map").setView(
        DEFAULT_MAP_CENTER,
        DEFAULT_MAP_ZOOM,
      );
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
        mapRef.current,
      );
    }

    const status = vehicleData ? getVehicleStatus(vehicleData) : null;
    const hasValidGPS =
      status !== "NO GPS" &&
      vehicleData?.Location?.Latitude &&
      vehicleData?.Location?.Longitude;

    if (hasValidGPS) {
      const { Latitude, Longitude } = vehicleData.Location;
      const bearing = vehicleData.calculatedBearing ?? vehicleData.Bearing ?? 0;
      const iconUrl = vehicleIcons[status] || vehicleIcons.UNKNOWN;

      const isNewVehicle = vehicleData.VehicleID !== mappedVehicleIdRef.current;
      if (isNewVehicle) {
        mapRef.current.flyTo([Latitude, Longitude], DEFAULT_LIVE_MAP_ZOOM, {
          duration: FLY_ANIMATION_DURATION,
        });
        mappedVehicleIdRef.current = vehicleData.VehicleID;
      } else {
        mapRef.current.setView([Latitude, Longitude], DEFAULT_LIVE_MAP_ZOOM);
      }

      if (markerRef.current) {
        markerRef.current.setLatLng([Latitude, Longitude]);
        const iconElement = markerRef.current.getElement();
        if (iconElement) {
          const img = iconElement.querySelector(".vehicle-icon-image");
          if (img) {
            if (img.src !== iconUrl) img.src = iconUrl;
            const currentRotation = smoothRotationRef.current;
            const newRotation = getShortestRotation(currentRotation, bearing);
            img.style.transition = "transform 0.7s ease-in-out";
            img.style.transform = `rotate(${newRotation}deg)`;
            smoothRotationRef.current = newRotation;
          }
        }
      } else {
        const icon = L.divIcon({
          className: "custom-leaflet-div-icon",
          html: `<img src="${iconUrl}" class="vehicle-icon-image" style="transform: rotate(${bearing}deg);">`,
          iconSize: [37, 37],
          iconAnchor: [18, 18],
        });
        markerRef.current = L.marker([Latitude, Longitude], { icon }).addTo(
          mapRef.current,
        );
        smoothRotationRef.current = bearing;
      }
    } else {
      if (markerRef.current) {
        mapRef.current.removeLayer(markerRef.current);
        markerRef.current = null;
      }
      if (mappedVehicleIdRef.current) {
        mapRef.current.flyTo(DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM, {
          duration: FLY_ANIMATION_DURATION,
        });
        mappedVehicleIdRef.current = null;
      }
    }
  }, [vehicleData]);

  const handleVehicleSelect = (vehicleId) => {
    setShowDropdown(false);
    setSelectedVehicleId(vehicleId);
    setCopied(false);
  };

  const filteredVehicles = allVehicles.filter(
    (v) =>
      v.VehicleID &&
      v.VehicleID.toLowerCase().includes(vehicleSearch.toLowerCase()),
  );

  const renderDetailsContent = () => {
    if (isLoading) return <DetailsSkeleton />;
    if (isError) return <div className="error">Error: {error.message}</div>;
    if (!vehicleData)
      return <div className="error">Vehicle data not found.</div>;
    const status = getVehicleStatus(vehicleData);
    return (
      <>
        <div>
          <p className="vehicleno-VehicleDetails">
            VEHICLE: {vehicleData.VehicleID}
          </p>
          <p className="vehicleno-VehicleDetails">
            Device ID: {vehicleData.DeviceID || "N/A"}
          </p>
          <p className="speed-VehicleDetails">
            Speed (km/h):{" "}
            <span className="font-semibold text-black">
              {(vehicleData.Speed || 0).toFixed(2)}
            </span>
          </p>
        </div>
        <div>
          <p className="detail-label-VehicleDetails">Last tracked time</p>
          <p className="tracking-time-VehicleDetails">
            {formatDate(vehicleData.LastTime)}
          </p>
        </div>
        <div>
          <p className="detail-label-VehicleDetails">Location</p>
          <p className="detail-value-VehicleDetails">
            {addressLoading ? "Loading address..." : address || "N/A"}
          </p>
        </div>
        <div>
          <p className="detail-label-VehicleDetails">Status</p>
          <p className="detail-value-VehicleDetails">{status}</p>
        </div>
        <hr className="divider-VehicleDetails" />
        <div className="details-grid-VehicleDetails">
          <div className="detail-block-VehicleDetails">
            <p className="detail-label-VehicleDetails">Driver Name</p>
            <p className="detail-value-VehicleDetails">
              {vehicleData.driverName || "N/A"}
            </p>
          </div>
          <div className="detail-block-VehicleDetails">
            <p className="detail-label-VehicleDetails">Driver License</p>
            <p className="detail-value-VehicleDetails">
              {vehicleData.driverLicense || "N/A"}
            </p>
          </div>
          <div className="detail-block-VehicleDetails">
            <p className="detail-label-VehicleDetails">Driver Contact</p>
            <p className="detail-value-VehicleDetails">
              {vehicleData.driverContact || "N/A"}
            </p>
          </div>
          <div className="detail-block-VehicleDetails">
            <p className="detail-label-VehicleDetails">Group Name</p>
            <p className="detail-value-VehicleDetails bold-VehicleDetails">
              {vehicleData.groupName || "N/A"}
            </p>
          </div>
        </div>
        <hr className="divider-VehicleDetails" />
        <div>
          <p className="detail-label-VehicleDetails">
            Total Distance (Past 3 Months)
          </p>
          <p className="detail-value-VehicleDetails">
            {vehicleData?.totalDistance ??
              vehicleData?.TotalDistance ??
              vehicleData?.total_distance ??
              "N/A"}{" "}
            Km
          </p>
        </div>
      </>
    );
  };

  return (
    <div className="main-container-VehicleDetails">
      <div className="screen-layout-VehicleDetails">
        <div className="info-panel-VehicleDetails">
          <div
            className="search-container-VehicleDetails"
            ref={searchContainerRef}
          >
            <label
              htmlFor="vehicle-number"
              className="search-label-VehicleDetails"
            >
              Vehicle Number
            </label>
            <div className="search-input-wrapper-VehicleDetails">
              <Search className="search-icon-VehicleDetails" />
              <input
                id="vehicle-number"
                type="text"
                value={vehicleSearch}
                onChange={(e) => {
                  setVehicleSearch(e.target.value);
                  setShowDropdown(true);
                }}
                className="search-input-VehicleDetails"
                autoComplete="off"
                placeholder="Search vehicle..."
              />
              {vehicleSearch && (
                <X
                  className="clear-search-icon-VehicleDetails"
                  onClick={() => setVehicleSearch("")}
                />
              )}
            </div>
            {showDropdown && (
              <ul className="search-results-list-VehicleDetails">
                {filteredVehicles.length > 0 ? (
                  filteredVehicles.map((v) => (
                    <li
                      key={v.VehicleID}
                      onClick={() => handleVehicleSelect(v.VehicleID)}
                      className="search-result-item-VehicleDetails"
                    >
                      {v.VehicleID}
                    </li>
                  ))
                ) : (
                  <li className="search-no-results-VehicleDetails">
                    No vehicles found
                  </li>
                )}
              </ul>
            )}
          </div>

          <div className="share-button-container-VehicleDetails">
            <button
              className={`share-button-VehicleDetails ${copied ? "copied-success" : ""}`}
              onClick={handleShareLiveLocation}
              disabled={isSharing || copied}
            >
              {isSharing ? (
                <div className="animate-spin-VehicleDetails"></div>
              ) : copied ? (
                <Check size={18} />
              ) : (
                <Share2 size={18} />
              )}
              <span>
                {isSharing
                  ? "GENERATING..."
                  : copied
                    ? "LINK COPIED!"
                    : "SHARE LIVE LOCATION"}
              </span>
            </button>
          </div>

          <div className="details-section-VehicleDetails">
            {renderDetailsContent()}
          </div>
        </div>

        <div className="map-panel-VehicleDetails">
          <div className="tracking-tabs-header">
            <button className="tracking-tab active">TRACKING LIVE</button>
            <button className="tracking-tab">TRAVEL REPLAY</button>
          </div>
          <div
            id="vehicle-map"
            className="map-placeholder-VehicleDetails"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default VehicleDetails;
